import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Session } from 'src/app/interfaces/session-data';
import { SessionService } from 'src/app/services/session/session.service';

@Component({
  selector: 'app-google-pay-payment-method',
  templateUrl: './google-pay.component.html',
  styleUrls: ['./google-pay.component.scss']
})
export class GooglePayComponent implements OnInit {
  link: string;
  private lock: boolean = false;
  private session:Session;
  constructor(
    private router:Router,
    private sessionService:SessionService,
    private route: ActivatedRoute
  ) {
    this.link = "card/google-pay";
  }

  ngOnInit(): void {
    this.session = sessionStorage.getItem("sessionData")? JSON.parse(sessionStorage.getItem("sessionData")) : null;
    this.selectMethod();
    this.sessionService.getPaymentMethodListLock().subscribe((lock:boolean) => {
      this.lock = lock;
    });
  }

  toggleListView(){
    this.sessionService.emitPaymentMethodPromotion("google-pay");
  }

  selectMethod(event?: Event){
    sessionStorage.setItem("selected-payment","google-pay");
    if(event!=undefined &&!this.lock){
      this.sessionService.setCurrencyCodeListLock(false);
      this.sessionService.emitSelectedPaymentMethod("google-pay");
      // this.router.navigate(['card/add'], { skipLocationChange: true, relativeTo: this.route } ).then(() => {
        this.router.navigate([this.link], {relativeTo: this.route});
      // });
      // this.router.navigate([this.link],{relativeTo: this.route});
    }
  }
}
